"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const mediaUtil_1 = require("@pbl/pbl-react-core/lib/utils/mediaUtil");
const ImageCard_1 = require("../../../card/ImageCard");
const assets_1 = require("../../../config/assets");
const config_1 = require("../../../config/config");
const QuickDrawGameCardStyle_1 = require("../../jss/QuickDrawGameCardStyle");
const QuickDrawImageCard = ({ selectedGame, quickDrawConfig }) => {
    const theme = (0, core_1.useTheme)();
    const classes = (0, QuickDrawGameCardStyle_1.default)(theme);
    const baseUri = !!config_1.config.internalConfig.BASE_URL ? config_1.config.internalConfig.BASE_URL : '';
    let imageUrl = assets_1.assets.internalAssets.noImage;
    if (!!quickDrawConfig && !!quickDrawConfig.sampleTicket) {
        imageUrl = quickDrawConfig.sampleTicket;
    }
    else if (!!selectedGame.ticketFullImage) {
        imageUrl = (0, mediaUtil_1.createMediaURL)(baseUri, '/media/api/file/', selectedGame.ticketFullImage);
    }
    const cornerIcon = {
        text: selectedGame.retailPrice.toCurrencyFormat(),
        contentColor: selectedGame.isActive
            ? config_1.config.themeColors.cornerColors.gameContrast.hex()
            : theme.palette.text.secondary,
        trianglePosition: { top: 0, left: 0 },
        triangleType: 'topLeft',
        triangleBackgroundColor: selectedGame.isActive
            ? config_1.config.themeColors.cornerColors.game.hex()
            : theme.palette.grey['400'],
        triangleSize: 88,
        iconClassName: classes.above
    };
    return ((0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ container: true, item: true, xs: 12, md: 6, lg: 5, xl: 4, className: classes.detailCardWrapper }, { children: (0, jsx_runtime_1.jsx)(ImageCard_1.default, { image: imageUrl, imageTitle: selectedGame.name, cornerIcon: cornerIcon, isCoverImage: true, imageHeight: config_1.config.internalConfig.SMALL_DRAW_GAMES_IMAGE_HEIGHT ? 350 : null }) })));
};
exports.default = QuickDrawImageCard;
//# sourceMappingURL=QuickDrawImageCard.js.map